import { render, staticRenderFns } from "./CandidateCardView.vue?vue&type=template&id=57e350d3"
import script from "./CandidateCardView.vue?vue&type=script&lang=js"
export * from "./CandidateCardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports